import * as Highcharts from 'highcharts';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts);
HighchartsAccessibility(Highcharts);

// Darker than COLORS.gray so the bando bars keep a 3:1 contrast against white.
export const BANDO_COLOR = '#80858c';

export default Highcharts;
